import React from 'react';

import { Icon } from '../icons';

export const ArrowTopLeftIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 16 16" fill={color} style={style}>
      <path d="M2.69129 4.02362L2.69129 2.90248C2.69129 2.42776 3.07511 2.04395 3.5473 2.04647L13.3624 2.04395C13.8371 2.04395 14.2209 2.42776 14.2184 2.89996L14.2184 12.7175C14.2184 13.1923 13.8346 13.5761 13.3624 13.5736L12.2412 13.5736C11.7614 13.5736 11.3751 13.1771 11.3852 12.6973L11.5291 6.75578L4.272 14.0129C3.93617 14.3488 3.39579 14.3488 3.05996 14.0129L2.25193 13.2049C1.91609 12.869 1.91609 12.3287 2.25193 11.9928L9.50906 4.7357L3.5675 4.87963C3.08521 4.89226 2.68877 4.50592 2.69129 4.02362Z" />
    </svg>
  );
};
